import { axios } from '@/utils/request'

const api = {
  dictType: '/system/dict/type'
}

export function getDictionary(parameter) {
  return axios({
    url: '/system/dict/data/list',
    method: 'get',
    params: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function getCancelReason (parameter) {
  return axios({
    url: '/order/business/cancelList',
    method: 'get',
    params: parameter
  })
}
